require('./RACancelPlanStep1.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @commons
const {
    SignaturePattern,
} = require('components/signaturePattern/signaturePattern');

// @constants
const {
    MULTIPLE_OPERATIONS,
    REMOVE_SCHEDULED_TRANSFER_ID,
} = require('constants/operationTypes');
const { EURO_TEXT } = require('constants/index');

class RACancelPlanStep1 extends React.Component {
    render() {
        const { immAccount, immPortfolio } = this.props;
        let partialQuery = {
            serviceCode: REMOVE_SCHEDULED_TRANSFER_ID,
        };

        if (immPortfolio.has('recurringTransfers')) {
            partialQuery = Object.assign(
                {
                    destinationAccount:
                        immAccount.getIn(['ibanComplex', 'pais']) +
                        immAccount.getIn(['ibanComplex', 'digitodecontrol']) +
                        immAccount.getIn(['ibanComplex', 'codbban']),
                    originAccount: immPortfolio.getIn([
                        'recurringTransfers',
                        'originalAccount',
                        'reference',
                    ]),
                    ammount: immPortfolio.getIn([
                        'recurringTransfers',
                        'amount',
                    ]),
                    currency: EURO_TEXT,
                },
                partialQuery,
            );
        }

        const operationParams = {
            requestMulti: [
                {
                    serviceCode: '160',
                },
                partialQuery,
            ],
            ammount: immPortfolio.getIn(['keyFigures', 'valuation']) //only for tagging
        };

        return (
            <div className="ra-cancel-plan-step1">
                <SignaturePattern
                    printTitleValue={'roboPrintTitle-cancelGestionDiscretion'}
                    customClassName="ra-cancel-plan-step1__signature-pattern"
                    operationType={MULTIPLE_OPERATIONS}
                    operationParams={operationParams}
                    displayTitle={false}
                    isWealth={true}
                />
            </div>
        );
    }
}

RACancelPlanStep1.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immPortfolio: PropTypes.object.isRequired,
};

module.exports = RACancelPlanStep1;
